import { Raycaster, Vector2 } from "three";
import EventEmitter from "eventemitter3";
import TouchControls from "./touch-controls";
import renderer from "../renderer";

export default class InteractiveObject extends EventEmitter {
  constructor(object, camera, options = {}) {
    super();
    this.object = object;
    this.camera = camera;
    this.options = Object.assign(
      {
        mouseMove: false, // raycast everytime the mouse moves
        touchStart: true, // only fires when clicking down on an object successfully
        touchMove: true, // fires when mouse or touch is moved on and off an object
        touchEnd: true, // fires when touch or mouse is released on and off an object
      },
      options
    );
    this.touchControls = new TouchControls(renderer.domElement, {
      hover: true,
    });
    this.raycaster = new Raycaster();
    this.coords = new Vector2();
    this.intersects = null;
    this.fired = {
      hoverOut: true, // Only fire hover out once per rollover
      hoverOver: false, // Only fire hover out once per rollover
    };
    this.bindEvents(true);
  }

  bindEvents = (bind) => {
    const listener = bind ? "on" : "off";
    if (this.options.touchStart)
      this.touchControls[listener]("start", this.onTouchStart);
    if (this.options.touchMove)
      this.touchControls[listener]("move", this.onTouchMove);
    if (this.options.touchMove)
      this.touchControls[listener]("mousemove", this.onTouchMove);
    if (this.options.touchEnd || this.options.touchMove)
      this.touchControls[listener]("end", this.onTouchEnd);
  };

  onTouchStart = (event) => {
    this.setCoords(event[0].normalX, event[0].normalY);
    this.intersected = this.raycast();
    if (this.intersected) this.emit("start", this.intersects[0]);
  };

  onTouchMove = (event) => {
    this.setCoords(event[0].normalX, event[0].normalY);
    this.intersected = this.raycast();
    this.hovering = this.intersected;
    if (this.intersected) {
      if (!this.fired.hoverOver || this.options.mouseMove)
        this.emit("hover", true, this.intersects[0]);
      this.fired.hoverOut = false;
      this.fired.hoverOver = true;
    } else if (!this.fired.hoverOut) {
      this.fired.hoverOut = true;
      this.fired.hoverOver = false;
      this.emit("hover", false);
    }
  };

  onTouchEnd = (event) => {
    if (this.hovering) {
      this.hovering = false;
      this.emit("hover", false);
    }
    if (this.intersected) {
      this.intersected = false;
      this.emit("end");
    }
  };

  setCoords = (normalX, normalY) => {
    this.coords.x = normalX * 2 - 1;
    this.coords.y = -normalY * 2 + 1;
  };

  raycast = () => {
    this.raycaster.setFromCamera(this.coords, this.camera);
    this.intersects = this.raycaster.intersectObject(this.object);
    return this.intersects.length > 0;
  };

  dispose = () => {
    this.touchControls.dispose();
    this.bindEvents(false);
  };
}
